import React from 'react';

const IconLightCross = props => (<svg viewBox="0 0 20 20" width="20px" height="20px" {...props}>
  <path d="M15.994 4.829l-0.836-0.838l-5.06 5.072l-5.06-5.072L4.203 4.829l5.06 5.072l-5.257 5.27l0.836 0.838l5.257-5.27l5.06 5.072 l0.836-0.838l-5.06-5.072L15.994 4.829z" />
</svg>);

export default IconLightCross;
